import React, { FunctionComponent } from 'react';
import { Dispatch } from 'redux';

import { connect } from 'react-redux';

import styled from 'styled-components';

import { Translate } from 'react-localize-redux';

import UserInviteSearchCtrl from '@webapp/controllers/user/user-invite-search';

//Store
import { CreateInvites } from '@webapp/store/invites/action-creators';
import { NewInviteDraft } from '@webapp/store/invites/action-creators';
import { EditInviteDraft } from '@webapp/store/invites/action-creators';
import AppState from '@webapp/store/state';
import { CREATE_INVITES } from '@webapp/store/invites/actions';

//Types
import SimpleArtist from '@common/types/artist/simple-artist';
import { Option } from '@webapp/types/common/option';
import SimpleUser from '@common/types/user/simple-user';
import { ArtistRelation } from '@common/types/artist/artist-relation';

//Service
import { TracInviteTypes } from '@services/invites/types/invite-types';
import { NewTracInvite } from '@services/invites/types/trac-invite';
import { NotificationVias } from '@common/types/notifications/notification-vias';

interface InviteTeamMemberListProps {
  className?: string;
  teamMembers: SimpleUser[];
  isLoading?: boolean;
  type: TracInviteTypes;
}

interface StateProps {
  missingMainArtist?: boolean;
  isLoading: boolean;
  currentArtistId: string;
  releaseId?: string;
  activeArtist: SimpleArtist;
  menuOptions: Option<ArtistRelation['role']>[];
  sendInvites: (type: TracInviteTypes) => CreateInvites;
  createDraftInvite: (
    type: TracInviteTypes,
    inviter: SimpleArtist
  ) => NewInviteDraft;
  editDraftInvite: (
    type: TracInviteTypes,
    key: string,
    invite: Partial<NewTracInvite>
  ) => EditInviteDraft;
}

export const RoleOptions: Option<ArtistRelation['role']>[] = [
  {
    value: 'member',
    label: 'Member',
    helpText: <Translate id="ARTIST_PROFILE.TEAM.INPUT.DROPDOWN.MEMBER.TEXT" />,
  },
  {
    value: 'manager',
    label: 'Manager',
    helpText: (
      <Translate id="ARTIST_PROFILE.TEAM.INPUT.DROPDOWN.MANAGER.TEXT" />
    ),
  },
];

const mapStateToProps = (state: AppState) => {
  const managerExists = state.artist.activeTeam.some(
    (member) => member.role === 'manager'
  );
  return {
    isLoading: !!state.ui.loading[CREATE_INVITES],
    menuOptions: RoleOptions.map((roleOption) => ({
      ...roleOption,
      disabled: managerExists && roleOption.value === 'manager',
    })),
    activeArtist: state.artist.active,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  sendInvites: (type: TracInviteTypes) => dispatch(new CreateInvites(type)),
  createDraftInvite: (type: TracInviteTypes, inviter: SimpleArtist) =>
    dispatch(new NewInviteDraft(type, inviter)),
  editDraftInvite: (
    type: TracInviteTypes,
    key: string,
    invite: Partial<NewTracInvite>
  ) => dispatch(new EditInviteDraft(type, key, invite)),
});

const InviteTeamMemberList: FunctionComponent<
  InviteTeamMemberListProps & StateProps
> = (props) => {
  const { className, teamMembers, isLoading, type } = props;

  const handleInvite = async (value: any) => {
    if (value.id === '' || teamMembers.some((val) => val.id === value.id)) {
      return;
    }
    props.createDraftInvite(type, props.activeArtist);
    [
      {
        email_or_phone: value.email || value.telephone,
        contact_type: (value.email ? 'email' : 'sms') as NotificationVias,
        name: value.fullName,
        role: 'member',
        type: props.type,
        metadata: {
          artist: props.activeArtist,
          inviter: props.activeArtist,
        },
        is_existing_user: true,
      },
    ].map((invite) =>
      props.editDraftInvite(type, invite.email_or_phone, invite)
    );
    props.sendInvites(type);
  };
  return (
    <div className={className}>
      <div className="invite-member-wrapper">
        <UserInviteSearchCtrl
          label={<Translate id="ARTIST_PROFILE.TEAM.INPUT.LABEL" />}
          currentValues={teamMembers}
          type={'team'}
          role={'member'}
          locked={isLoading}
          onSelection={(value) => {
            handleInvite(value);
          }}
          customBorderRadius="4px 0 0 4px"
        />
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(InviteTeamMemberList)`
  .invite-member-wrapper {
    position: relative;
    width: 100%;

    & > * {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: 35%;

      &:first-child {
        flex-basis: 65%;
      }

      ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
        flex-basis: 30%;

        &:first-child {
          flex-basis: 70%;
        }
      }
    }
  }
`);
